<script lang="ts">
  import { _ } from 'svelte-i18n';
  export let label = '';
  export let value = '';
  export let reset = () => {}; // function that clears the value
  export let isSimilarity = false; // Flag for similarity pills

  // Optional: could also take an icon or slot for future flexibility
</script>

<div
  class="flex items-center gap-1 rounded-full px-3 py-1 text-xs font-light {isSimilarity
    ? 'bg-accent-100 text-accent-900'
    : 'bg-accent-100 text-accent-900'}"
>
  <span class="flex items-center gap-1.5">
    <svg
      class="h-2 w-2 flex-shrink-0 {isSimilarity ? 'text-accent-500' : 'text-accent-500'}"
      fill="currentColor"
      viewBox="0 0 8 8"
    >
      <circle cx="4" cy="4" r="3" />
    </svg>
    {#if $$slots.default}
      <slot />
    {:else if value}
      <span class="whitespace-nowrap">{label}: {value}</span>
    {:else}
      <span class="whitespace-nowrap">{label}</span>
    {/if}
  </span>

  <div
    on:click={reset}
    class="ml-2 transition duration-150 hover:text-red-600 {isSimilarity
      ? 'text-accent-600'
      : 'text-accent-600'}"
    aria-label={$_('a11y.removeFilter')}
  >
    ✕
  </div>
</div>
